import axios from "axios";
import { Identifiant } from "../../Models/Identifiant/IdentifiantModels"
import { URL_MIDIS, URLAPI } from "../../Setting";
import { errorService } from "../Error/ErrorService";
import { ClientService } from "../Client/ClientService";

export function IdentifiantService(){
    return{
        async getIdentifiantsFromUrlsToPromiseToClient(urls:string[], token:string):Promise<Identifiant[]>{
            let identifiants:Identifiant[]=[];
            if(urls.length>0){
                for(const url of urls){
                    try {
                        const response = await axios.get(`${URL_MIDIS+url}`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type":"application/ld+json"
                            },
                        });
                        const data = response.data['hydra:member'];
                        if(data.length>0){
                            identifiants = [...identifiants,{
                                id:data[0]['id'],
                                login:data[0]['login'],
                                role:data[0]['role'],
                                roles:data[0]['roles'],
                                actif:true,
                                userIdentifier:data[0]['userIdentifier'],
                                clients:data[0]['clients'].map((client: any)=>{return {'@id':client}})
                            }];
                        }
                    } catch (error) {
                        errorService().handleError('Erreur lors du getIdentifiantsFromUrlsToPromiseToClientForAdmin', error)
                        return []
                    }
                }
            }
            return identifiants;
        },

        async getIdentifiants(token:string):Promise<Identifiant[]>{
            let identifiants:Identifiant[]=[];
            try {
                const response = await axios.get(`${URLAPI+"identifiants"}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                for(const element of data){
                    identifiants.push({
                        id:element['id'],
                        login:element['login'],
                        role:element['role'],
                        roles:element['roles'],
                        actif:true,
                        userIdentifier:element['userIdentifier'],
                        clients:element['clients'].map((client: any)=>{return {'@id':client}}),
                    });
                }
            } catch (error) {
                errorService().handleError('Erreur lors du getIdentifiantsFromUrlsToPromiseToClientForAdmin', error)
                return []
            }
            return identifiants;
        },

        async postIdentifiant(login:string, password:string, role:string, idClient:number, token:string){
            let status = 0;
            const postIdentifiantObject = {
                "login": login,
                "password": password,
                "role": role
            };

            const responsePOSTIdentifiant = await axios.post(
                `${URLAPI+'identifiant'}`,
                postIdentifiantObject,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/ld+json',
                    },
                }
            );
            const responseIDPostIndetifiant = responsePOSTIdentifiant.data['id'];
            if(responsePOSTIdentifiant.status===201||responsePOSTIdentifiant.status===200){
                const client = await ClientService().getClient(idClient, token);
                const getIDIdentifiants = client.identifiants?.map(identifiant => identifiant.id);
                getIDIdentifiants?.push(responseIDPostIndetifiant);
                const patchClientObject = {
                    "identifiants": getIDIdentifiants
                }
                const responsePATCHClient = await axios.patch(
                    `${URLAPI+'client/'+client.id}`,
                    patchClientObject,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                status = responsePATCHClient.status;
            }
            return status;
        }
    }
}
